import CategoryResultFull from './CategoryResultFull';

export default CategoryResultFull;
